// extracted by mini-css-extract-plugin
module.exports = {"text":"Success-module__text___20uqB Fonts-module__bt___102gf"};